// HO-TASK-301: interruptor de Homelan Rewards. Apagado, la web no muestra nada
// del programa (menú, rutas, widgets, canje, referidos ni notificaciones) y no
// llama a su API. En los builds solo se enciende con VITE_REWARDS_ENABLED=true
// (staging); en desarrollo local viene encendido salvo que valga 'false'.
export const REWARDS_ENABLED = import.meta.env.DEV
  ? import.meta.env.VITE_REWARDS_ENABLED !== 'false'
  : import.meta.env.VITE_REWARDS_ENABLED === 'true';
